const preDmAppointmentList = () => import('@/modules/pre_dm/appointment/List.vue')

const preDmRoutes = [
    {
        path: '/pre-dm',
        name: 'preDm',
        children: [
            {
                path: 'appointment',
                redirect: { name: 'preDmAppointmentsHistory' }
            },
            {
                path: 'appointment/:type(current)',
                name: 'preDmAppointmentsCurrent',
                component: preDmAppointmentList,
                meta: {
                    resource: 'pre-dm-appointment-current',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'PreDM Appointment Current',
                    breadcrumbs: [{ title: 'PreDM Appointment Current', routeName: 'preDmAppointmentsCurrent' }]
                }
            },
            {
                path: 'appointment/:type(history)',
                name: 'preDmAppointmentsHistory',
                component: preDmAppointmentList,
                meta: {
                    resource: 'pre-dm-appointment-history',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'PreDM Appointment History',
                    breadcrumbs: [{ title: 'PreDM Appointment History', routeName: 'preDmAppointmentsHistory' }]
                }
            },
            {
                path: 'users',
                name: 'preDmUsersList',
                component: () => import('@/modules/pre_dm/users/List.vue'),
                meta: {
                    resource: 'pre-dm-users',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'PreDM Users',
                    breadcrumbs: [{ title: 'PreDM Users', routeName: 'preDmUsersList' }]
                }
            }
        ]
    }
]

export default preDmRoutes
